/**
 * Switch
 *
 * @selector [data-js-switch]
 * @enabled true
 */
import BaseModule from '../../modules/BaseModule.js';
import { isClickOutside } from '../../../lib/util/isClickOutside.js';

export default class Switch extends BaseModule {
    constructor() {
        super();
    }

    init(element) {
        this.el = element;
        this.$el = $(element);

        this.$openBtn = $(this.$el).find('[data-js-switch--open]');
        this.$closeBtn = $(this.$el).find('[data-js-switch--close]');
        this.opensToTop = Boolean($(this.$el).attr('class').includes('up'));
        this.opensToBottom = !this.opensToTop;

        this.bindListener();

        return this;
    }

    bindListener() {
        this.on(document, 'click', this.onClickOutside);
        $(this.$openBtn).on('click', (e) => this.toggleDropdown(e));
        $(this.$closeBtn).on('click', (e) => this.onCloseButtonClick(e));
    }

    onClickOutside(e) {
        if (isClickOutside(this.el, e.target)) {
            this.closeAll();
        }
    }

    closeAll() {
        $(this.$el).addClass('closed');
        $(this.$el).removeClass('is-open');
    }

    toggleDropdown(e) {
        e.preventDefault();
        $(this.$el).toggleClass('closed');
        $(this.$el).toggleClass('is-open');
    }

    onCloseButtonClick() {
        this.closeAll();
        this.$openBtn[0].focus();
    }
}
